import React from 'react'

import { Field } from 'formik'

import { Form } from '_zari/core'

const FlagCodigoSunatFormGroup = ({ iValue, fIsSubmitting }) => {
  return (
    <Field name='flagCodigoSunat'>
      {({ field }) => (
        <Form.Checkbox {...field} checked={iValue} disabled={fIsSubmitting} id='checkbox-flagCodigoSunat' label='Uso de código SUNAT' />
      )}
    </Field>
  )
}

export default React.memo(FlagCodigoSunatFormGroup)
